<template>
	<b-modal
		no-close-on-backdrop
		no-close-on-esc
		:visible="value"
		@close="$emit('reset')"
		size="sm"
		body-class="position-static"
		hide-header
		centered
	>
		El servicio actualizará el estado del portal Web Check-in a
		<strong>{{ changeServiceStatusLabel }}</strong>
		<hr />
		<b-form-group label="Registra una nota">
			<b-textarea v-model="changeStatusNote" />
		</b-form-group>

		<template #modal-footer="{ close }">
			<b-button
				:disabled="changeStatusLoading"
				@click="close()"
				type="button"
				class="float-right"
			>
				Cancelar
			</b-button>
			<b-button
				:disabled="changeStatusLoading"
				@click="doChangeStatus"
				type="button"
				variant="primary"
				class="float-right"
			>
				<span v-if="!changeStatusLoading">Actualizar estado</span>
				<span v-else><b-spinner small></b-spinner> Procesando...</span>
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import api from "@/api.js";
import { mapActions } from "vuex";
export default {
	props: {
		value: Boolean,
		modelId: Number,
		copyFromId: Number,
        status: String,
        serviceId: [Number,String]
	},
	data: () => ({
		changeStatusNote: "",
		changeStatusLoading: false
	}),
	computed: {
		changeServiceStatusLabel() {
			return this.$root.auxVars.webCheckingStatus.find(
				aux => aux.value === this.status
			)?.text;
		}
	},
	methods: {
		...mapActions("reservation", ["_fetchModel", "_fetchNotes"]),
		async fetchModel() {
			await this._fetchModel({
				context: this,
				modelId: this.modelId,
				copyFromId: this.copyFromId
			});
		},
		async fetchNotes() {
			await this._fetchNotes({ context: this, modelId: this.modelId });
		},
		doChangeStatus() {
			this.changeStatusLoading = true;
			api(this)
				.post(
					`/transport-services/change-webcheckin-status/${this.serviceId}`,
					{
						note: this.changeStatusNote,
						status: this.status
					}
				)
				.then(() => {
					this.$root.showAlert("Servicio actualizado con éxito");
					this.changeStatusLoading = false;
					this.changeStatusNote = "";
					this.fetchModel();
					this.fetchNotes();
					this.$emit('reset');
					this.$root.$emit(
						"bv::refresh::table",
						"reservations-index-list"
					);
				})
				.catch(this.$root.handleRequestError);
		}
	}
};
</script>

<style></style>
